import { SURVEY_DATA_ACTIONS } from '../../dataFetchers/surveyDataFetchers';
import { SURVEY_ACTIONS } from '../../actions/surveyActions';

import { PENDING } from '../../constants/common';

const surveyReducers = (state = {
    surveyQuestionsData: [],
    currentQuestionObject: null,
    currentQuestionIndex: 0,
    currentAnswer: null,
    surveyAnswers: [],
    sliderValue: 0,
    surveyFinished: false,
    isSurveyLoading: false,
    surveySubmissionTimestamp: null,
    isDisaggRunning: false,
    surveyDisaggStatus: null
}, action) => {
    switch(action.type) {
        case SURVEY_DATA_ACTIONS.FETCH_SURVEY_DATA: {
            let surveyQuestionsData = action.payload.questions;
            surveyQuestionsData = surveyQuestionsData.map(questionObj => {
                questionObj.originalAns = questionObj.answers;
                return questionObj;
            });
            state = {
                ...state,
                surveyQuestionsData: surveyQuestionsData,
                currentQuestionObject: action.payload.questions[0],
                currentAnswer: action.payload.questions[0].answers,
                sliderValue: 0,
                isSurveyLoading: false,
                surveyFinished: false,
                isDisaggRunning: false,
                surveyDisaggStatus: null
            }
            break;
        }
        case SURVEY_ACTIONS.SURVEY_SET_ANSWER: {
            let surveyQuestionsData = state.surveyQuestionsData;
            let index = surveyQuestionsData.findIndex(item => item === state.currentQuestionObject);
            surveyQuestionsData[index].answers = action.payload;
            state = {
                ...state,
                surveyQuestionsData: surveyQuestionsData,
                currentAnswer: action.payload
            };
            break;
        }
        case SURVEY_ACTIONS.SURVEY_SET_NEXT_QUESTION: {
            let answers = [...state.surveyAnswers];
            answers.push({
                "questionId": state.currentQuestionObject.id,
                "value": state.currentAnswer
            });
            state = {
                ...state,
                surveyAnswers: answers,
            };
            let newCurrentQuestionObject = null;
            for (let i = 0; i < state.surveyQuestionsData.length; i++) {
                if (state.currentQuestionObject.order >= state.surveyQuestionsData[i].order) {
                    continue;
                }
                if (state.surveyQuestionsData[i].parent) {
                    //find the parent question by comparing current question's parent's id and answered arrays' questions' id
                    for (let j = 0; j < state.surveyAnswers.length; j++ ) {
                        if (state.surveyAnswers[j].value && state.surveyQuestionsData[i].parent.id === state.surveyAnswers[j].questionId) {
                            //check if the answers given contains the array of answers for which the child question should be asked
                            if (state.surveyAnswers[j].value.filter(value => state.surveyQuestionsData[i].parent.value.includes(value)).length) {
                                newCurrentQuestionObject = state.surveyQuestionsData[i];
                                break;
                            }
                        }
                    }
                    //if parent is found, break
                    if (newCurrentQuestionObject) {
                        break;
                    }
                }else {
                    newCurrentQuestionObject = state.surveyQuestionsData[i];
                    break;
                }
            }
            if (newCurrentQuestionObject) {
                state = {
                    ...state,
                    currentAnswer: newCurrentQuestionObject.answers,
                    currentQuestionObject: newCurrentQuestionObject,
                    currentQuestionIndex: newCurrentQuestionObject.order,
                    sliderValue: Math.round((newCurrentQuestionObject.order - 1) / state.surveyQuestionsData[state.surveyQuestionsData.length - 1].order * 100)
                };
            }else {
                state = {
                    ...state,
                    currentQuestionObject: null,
                    currentQuestionIndex: 0,
                    currentAnswer: null,
                    sliderValue: 100,
                    surveyFinished: true
                };
            }
            break;
        }
        case SURVEY_ACTIONS.SURVEY_SET_PREVIOUS_QUESTION: {
            let answers = [...state.surveyAnswers];
            //get last answered question and remove the last answer from array
            let lastAnswer = answers.pop();
            let lastQuestion = null;
            //get question object of last answered question
            for (let i = 0; i < state.currentQuestionIndex; i++) {
                if (state.surveyQuestionsData[i].id === lastAnswer.questionId) {
                    lastQuestion = state.surveyQuestionsData[i];
                    break;
                }
            }
            state = {
                ...state,
                currentAnswer: lastAnswer.value,
                currentQuestionObject: lastQuestion,
                currentQuestionIndex: lastQuestion.order,
                surveyAnswers: answers,
                sliderValue: Math.round((lastQuestion.order - 1) / state.surveyQuestionsData[state.surveyQuestionsData.length - 1].order * 100)
            };
            break;
        }
        case SURVEY_DATA_ACTIONS.SAVED_SURVEY_DATA: {
            state = {
                ...state,
                isSurveyLoading: state.isDisaggRunning ? state.isSurveyLoading : false,
            };
            break;
        }
        case SURVEY_DATA_ACTIONS.CALL_DISAGG_API: {
            state = {
                ...state,
                isSurveyLoading: true,
                isDisaggRunning: true,
                surveySubmissionTimestamp: action.payload.surveySubmissionTimestamp,
                surveyFinished: true
            };
            break;
        }
        case SURVEY_DATA_ACTIONS.CHECK_DISAGG_STATUS: {
            let isSurveyPending = (action.payload.status === PENDING);
            state = {
                ...state,
                isSurveyLoading: isSurveyPending,
                isDisaggRunning: isSurveyPending,
                surveySubmissionTimestamp: !isSurveyPending ? null : state.surveySubmissionTimestamp,
                surveyDisaggStatus: action.payload.status,
                surveyAnswers: isSurveyPending ? state.surveyAnswers : []
            };
            break;
        }
        case SURVEY_ACTIONS.UPDATE_CURRENT_QUESTION: {
            const questionIndex = action.payload.currentQuestionIndex;
            const surveyQuestionsData = state.surveyQuestionsData;
            state = {
                ...state,
                currentQuestionObject: action.payload.currentQuestionObject,
                currentQuestionIndex: questionIndex,
                currentAnswer: action.payload.currentAnswer,
                sliderValue: Math.round((surveyQuestionsData[questionIndex].order - 1) / surveyQuestionsData[surveyQuestionsData.length - 1].order * 100),
                surveyAnswers: action.payload.surveyAnswers
            };
            break;
        }
        case SURVEY_ACTIONS.SURVEY_CLEAR_DATA: {
            state = {
                ...state,
                surveyQuestionsData: [],
                currentQuestionObject: null,
                currentQuestionIndex: 0,
                currentAnswer: null,
                surveyAnswers: [],
                sliderValue: 0,
                surveyFinished: false,
                isSurveyLoading: false,
                surveySubmissionTimestamp: null,
                isDisaggRunning: false,
                surveyDisaggStatus: null
            }
            break;
        }
        default:
            break;
    }
    return state;
}

export default surveyReducers;
